import { Injectable } from '@angular/core';
import { FirebaseService } from './firebase.service';
import { FirebaseListObservable, FirebaseObjectObservable } from 'angularfire2/database';
import * as firebase from "firebase";
import * as _ from 'underscore';

@Injectable()
export class IngredientService {
	private db;
	ingredients: FirebaseListObservable<Ingredient[]>;
	tes: any;
	s;

	constructor(private firebaseService: FirebaseService) {
		this.db = firebaseService.db;
		this.loadIngredients();
	}

	/**
	 * Load initial data
	 */
	loadIngredients() {
		window.dispatchEvent(new Event('loading'));
		this.ingredients = this.db.list('/ingredients', {
			query: {
				orderByChild: 'product_name'
			}
		}) as FirebaseListObservable<Ingredient[]>
		this.ingredients.subscribe(data => {
			this.triggerDataChange();
		});

		return this.ingredients;
	}

	triggerDataChange() {
		window.dispatchEvent(new Event('data-loaded'));
	}

	/**
	 * Get All Ingredients
	 */
	getIngredients() {
		return this.ingredients;
	}

	/**
	 * Get Ingredient by ID
	 * @param {string} id : Item ID
	 */
	getIngredient(id: string) {
		return this.db.object('/ingredients/' + id) as FirebaseObjectObservable<Ingredient>;
	}

	/**
	 * Add new Ingredient
	 * @param {Ingredient} ingredient
	 */
	addIngredient(ingredient) {
		return this.ingredients.push(ingredient);
	}

	/**
	 * Update Ingredient Data
	 * @param {string} id   : Item ID
	 * @param {object} data : Updated data
	 */
	updateIngredient(id: string, data: Ingredient): firebase.Promise<void> {
		if(!id)
		{
			return new Promise<any>((resolve, reject) => {
				reject('ID must provided.');
			});
		}

		var ingredient = this.getIngredient(id);
		data.updated_at = (new Date()).getTime();
		if (!data.created_at) {
			data.created_at = (new Date()).getTime();
		}
		return ingredient.update(data);
	}

	/**
	 * Delete Ingredient
	 * @param {string} id : Item ID
	 */
	deleteIngredient(id: string) {
		var promise = new Promise<any>((resolve, reject) => {
			if(!id){
				reject('ID must provided.');
			}
			else
			{
				var result = this.ingredients.remove(id).then(data => {
					this.triggerDataChange();
					resolve(data);
				})
			}
		})
		return promise;
	}
}

export class Ingredient {
	$key?: string;
	product_name?: string = '';
	price?: number = 0;
	product_status?: string = '';
	category_id?: string = '';
	// ecoll_status?:string = '';
	format?: string = '';
	halal_status?: string = '';
	shelf_life?: number = 0;
	solubility?: string = '';
	application_suggestion?: string = '';
	description?: string = '';
	packaging_size?: string[] = [];
	moq?: string[] = [];
	product_list?: string = '';
	lead_time?: string = '';

	doc_spec?: string = '';
	doc_MSDS?: string = '';
	doc_TDS?: string = '';
	doc_halal?: string = '';

	tonality_id?: string = '';
	gin_id?: string = '';
	gin?: string = '';
	color_shade_id?: string = '';
	pigment_id?: string = '';

	sap_code?: string = "";

	created_at?: number;
	updated_at?: number;

	constructor() {
		var now = new Date();
		this.created_at = now.getTime();
		this.updated_at = now.getTime();
	}

	add_packaging_size() {
		this.packaging_size.push('');
	}

	remove_packaging_size(index) {
		this.packaging_size.splice(index, 1);
	}

	add_moq() {
		this.moq.push('');
	}

	remove_moq(index) {
		this.moq.splice(index, 1);
	}
}



// WEBPACK FOOTER //
// D:/www/kh_indesso_web/src/app/services/ingredient.service.ts